import React from 'react';

class List extends React.Component{
    render () {
       const {sorted_categories, handleCheckbox, clicked, title} = this.props
        let list = []
        if(sorted_categories){
        sorted_categories.map((item, index) => {
            list.push(
                <div className="checkbox" key={index}>
                    <label>
                        <input className="pointer" type="checkbox" value={item.slug} onChange={handleCheckbox} checked={clicked[index]}/>{item.name}
                    </label>
                </div>
                )
                return list
            })
        }
        return(
            <div className="col-sm-6">
                <p>{title}:</p>
                {list}
            </div>
        )    
    }
}

export default List;